<template>
  <div>
    <el-row :gutter="15">

      <el-col>
        <el-card class="card">
          <div slot="header"
               class="card-header"><i class="el-icon-font el-icon-zuzhijigou el-icon--left"></i>巡检项</div>
          <div class="es-op-box">
            <el-input placeholder="巡检项名称"
                      v-model="queryObj.label"
                      size="small"
                      class="query"
                      style="float: left"
                      clearable
                      @change="() => {
                  this.queryObj.pageNum = 1
                  this.loaditemdetailList()

                }
                ">
              <i slot="suffix"
                 class="el-input__icon el-icon-search"></i>
            </el-input>

            <el-input placeholder="对象类型"
                      v-model="queryObj.typeIdName"
                      size="small"
                      class="query"
                      style="float: left"
                      clearable
                      @change="() => {
                  this.queryObj.pageNum = 1
                  this.loaditemdetailList()

                }
                ">
              <i slot="suffix"
                 class="el-input__icon el-icon-search"></i>
            </el-input>

            <el-select v-model="queryObj.instypeId"
                       style="float: left"
                       size="small"
                       class="query"
                       clearable
                       placeholder="请选择巡检类别"
                       @change="() => {
                  this.queryObj.pageNum = 1
                  this.loaditemdetailList()
                }">
              <el-option v-for="item in instype"
                         :key="item.value"
                         :label="item.label"
                         :value="item.value">
              </el-option>
            </el-select>

            <el-button type="primary"
                       icon="el-icon-font el-icon-web__tianjia"
                       size="mini"
                       style="margin-right:6px"
                       @click="itemdetailAdd">新增</el-button>
            <es-delete @del="itemdetailDel()"
                       type="button"></es-delete>
          </div>
          <el-table :data="itemdetailPageData.list"
                    ref="itemdetailTable"
                    border
                    size="mini"
                    height="calc(100vh - 250px)"
                    v-loading="loadingItemdetail">
            <el-table-column type="selection"
                             width="40"
                             align="center">
            </el-table-column>
            <el-table-column type="index"
                             label="序号"
                             width="50"
                             align="center">
            </el-table-column>
            <el-table-column prop="instypeName"
                             label="巡检类别">
            </el-table-column>
            <el-table-column prop="typeIdName"
                             label="对象类型">
            </el-table-column>
            <el-table-column prop="sysName"
                             label="所属系统">
              this.itemdetailInfo.instypeId == 1
              <template slot-scope="scope">
                <span v-if="scope.row.instypeId == 1"></span>
                <span v-if="scope.row.instypeId == 2">{{ scope.row.sysName }}</span>
              </template>

            </el-table-column>
            <!-- <el-table-column prop="code" label="编码">
            </el-table-column> -->
            <el-table-column prop="label"
                             label="巡检项名称">
            </el-table-column>
            <el-table-column prop="type"
                             label="字段类型">
              <template slot-scope="scope">
                <span v-if="scope.row.type == 1">文本框</span>
                <span v-if="scope.row.type == 2">下拉框</span>
                <span v-if="scope.row.type == 3">文本域</span>
              </template>
            </el-table-column>
            <!--
            <el-table-column prop="isRequired"
                            
                             label="是否必输"
                             align="center">
                <template slot-scope="scope">
                  <span v-if="scope.row.isRequired == 1">必输</span>
                  <span v-if="scope.row.isRequired == 0">不必输</span>                  
                </template>
            </el-table-column> -->
            <el-table-column prop="dictFatherName"
                             label="字典表名称">
              <template slot-scope="scope">
                <span v-if="scope.row.type == 2">{{ scope.row.dictFatherName }}</span>
              </template>
            </el-table-column>

            <!-- <el-table-column prop="defaultValue"
                             label="巡检项默认值">
            </el-table-column> -->
            <el-table-column prop="maxSize"
                             label="最大长度">
              <template slot-scope="scope">
                <span v-if="scope.row.type != 2">{{ scope.row.maxSize }}</span>
              </template>
            </el-table-column>

            <el-table-column label="操作"
                             width="80"
                             align="center">
              <template slot-scope="scope">
                <el-link :underline="false"
                         title="编辑"
                         @click="editItemdetailinit(scope.row)"
                         type="primary"><i class="el-icon-font el-icon-bianji"></i></el-link>
                <el-divider direction="vertical"></el-divider>
                <es-delete @del="itemdetailDel(scope.row.id)"
                           :key="scope.row.id"
                           type="icon"></es-delete>
              </template>
            </el-table-column>
          </el-table>
          <div class="es-page-box">
            <es-pagination :data="itemdetailPageData"
                           @change="(cpage) => { this.queryObj.pageNum = cpage; this.loaditemdetailList() }">
            </es-pagination>
          </div>

        </el-card>
      </el-col>

    </el-row>

    <!--编辑详情信息-->
    <el-dialog :visible.sync="edititemdetailVisible"
               @closed="() => this.$refs['itemdetailForm'].clearValidate()"
               width="500px">
      <span slot="title">
        <i class="el-icon-font el-icon-bianji el-icon--left"></i>编辑巡检项
      </span>
      <el-form :model="itemdetailInfo"
               :rules="editItemdetailRules"
               size="mini"
               label-position="right"
               label-width="150px"
               ref="itemdetailForm">

        <el-form-item prop="instypeId"
                      label="巡检类别">
          <el-select v-model="itemdetailInfo.instypeId"
                     style="float: left"
                     size="small"
                     class="query"
                     placeholder="请选择巡检类别"
                     @change="doatypelist()">
            <el-option v-for="item in instype"
                       :key="item.value"
                       :label="item.label"
                       :value="item.value">
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item prop="typeId"
                      label="巡检对象类型">
          <el-select v-model="itemdetailInfo.typeId"
                     style="float: left"
                     size="small"
                     class="query"
                     filterable
                     placeholder="巡检对象类型">
            <el-option v-for="item in doaType"
                       :key="item.value"
                       :label="item.label"
                       :value="item.value">
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item v-if="itemdetailInfo.instypeId == 2"
                      prop="sysId"
                      label="系统">
          <el-select v-model="itemdetailInfo.sysId"
                     placeholder="请选择所属系统">
            <el-option v-for="item in sysList"
                       :key="item.id"
                       :label="item.name"
                       :value="item.id">
            </el-option>
          </el-select>
        </el-form-item>
        <!-- <el-form-item prop="code" label="编码">
          <el-input v-model="itemdetailInfo.code" placeholder="请输入编码" style="width:200px" clearable>
          </el-input>
        </el-form-item> -->

        <el-form-item prop="label"
                      label="巡检项名称">
          <el-input v-model="itemdetailInfo.label"
                    placeholder="请输入巡检项名称"
                    style="width:200px"
                    clearable>
          </el-input>
        </el-form-item>
        <el-form-item prop="type"
                      label="对象类型">
          <el-select v-model="itemdetailInfo.type"
                     @change="detailtypeinit()"
                     placeholder="请选择对象字段类型">
            <el-option v-for="item in externtype"
                       :key="item.value"
                       :label="item.label"
                       :value="item.value">
            </el-option>
          </el-select>
        </el-form-item>

        <!--
        <el-form-item prop="isRequired"
                      label="是否必输">
              <el-select v-model="itemdetailInfo.isRequired"  placeholder="请选择内容是否必输">
                <el-option v-for="item in isRequireds"
                       :key="item.value"
                       :label="item.label"
                       :value="item.value">
                </el-option>                             
              </el-select>          
        </el-form-item> -->

        <el-form-item v-if="dictVisible == true"
                      prop="dictFatherId"
                      label="字典表名称">
          <el-select v-model="itemdetailInfo.dictFatherId"
                     @change="initdictsonlist()"
                     placeholder="">
            <el-option v-for="item in dictfathers"
                       :key="item.id"
                       :label="item.name"
                       :value="item.id">
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item prop="defaultValue"
                      label="巡检项默认值">
          <el-input v-model="itemdetailInfo.defaultValue"
                    v-if="itemdetailInfo.type=='1'"
                    placeholder="请输入巡检项默认值"
                    style="width:200px"
                    clearable>
          </el-input>
          <el-select v-model="itemdetailInfo.defaultValue"
                     v-if="itemdetailInfo.type=='2'"
                     placeholder="请选择巡检项默认值">
            <el-option v-for="item in sonlist"
                       :key="item.id"
                       :label="item.name"
                       :value="item.value +''">
            </el-option>
          </el-select>
          <el-input v-model="itemdetailInfo.defaultValue"
                    v-if="itemdetailInfo.type=='3'"
                    placeholder="请输入巡检项默认值"
                    type="textarea"
                    :rows="2"
                    style="width: 200px"
                    clearable>
          </el-input>
        </el-form-item>
        <el-form-item prop="maxSize"
                      v-if="maxVisible == true"
                      label="最大长度">
          <el-input-number v-model="itemdetailInfo.maxSize"
                           style="width:200px"
                           :max=100
                           controls-position="right">
          </el-input-number>
        </el-form-item>
      </el-form>
      <span slot="footer">
        <el-button size="mini"
                   @click="edititemdetailVisible = false">取 消</el-button>
        <el-button type="primary"
                   size="mini"
                   @click="submititemdetail()"
                   :loading="saving">保 存</el-button>
      </span>
    </el-dialog>

  </div>
</template>

<script>
export default {
  name: 'item',
  props: ["funcs"],
  data () {
    return {

      queryObj: { pageNum: 1, pageSize: 20, label: "" },//查询条件
      sonlist: [],
      instype: [
        { value: 1, label: "设备巡检" },
        { value: 2, label: "区域巡检" }
      ],

      isRequireds: [
        { value: 1, label: "必输" },
        { value: 0, label: "不必输" }
      ],

      externtype: [
        { value: 1, label: "文本框" },
        { value: 2, label: "下拉框" },
        { value: 3, label: "文本域" }
      ],

      sysList: [],
      doaType: [],
      dictfathers: [],
      itemdetailPageData: {},
      edititemdetailVisible: false,
      maxVisible: true,
      itemdetailInfo: {},//详情信息    
      editItemdetailRules: {//子节点验证条件
        instypeId: [
          { required: true, message: '请选择巡检类别', trigger: 'blur' },
        ],
        typeId: [
          { required: true, message: '请选择巡检对象', trigger: 'blur' },
        ],
        sysId: [
          { required: true, message: '请选择系统', trigger: 'blur' },
        ],
        // code: [
        //   { required: true, message: '请输入编码', trigger: 'blur' },
        //   { max: 20, message: '不能超过20个字符', trigger: 'blur' }
        // ],
        label: [
          { required: true, message: '请输入扩展字段名称', trigger: 'blur' },
          // { max: 100, message: '不能超过100个字符', trigger: 'blur' }
        ],
        type: [
          { required: true, message: '请选择合适的扩展字段类型', trigger: 'blur' },
        ],
        /*  isRequired: [
           { required: true, message: '请选择是否必输', trigger: 'blur' },         
         ], */

        dictFatherId: [
          { required: true, message: '请选择字典列表名称', trigger: 'blur' },
        ],

        maxSize: [
          { required: true, message: '请输入字段长度', trigger: 'blur' },
        ],
      },


      dictVisible: true,
      loadingItemdetail: false,
      saving: false,
    }
  },
  methods: {
    //页面初始化
    init () {
      this.loaditemdetailList()
      this.initdictfathers()
      this.initsys()
    },

    //通过巡检类别查询对象类型
    doatypelist () {
      this.loadingitem = true
      this.$ajax.get('/buss/item/doatypelist', this.itemdetailInfo).then(msg => {
        this.doaType = msg
        this.loadingitem = false
      }).catch(err => {
        this.$message.error(err)
        this.loadingitem = false
      })
    },

    initsys () {
      this.loading = true
      this.$ajax.get('/base/system/listAll',).then(msg => {
        this.sysList = msg
        this.loading = false
      }).catch(err => {
        this.$message.error(err)
        this.loading = false
      })
    },

    initdictfathers () {
      this.loading = true
      this.$ajax.get('/base/dic/listfathersall', this.queryObj).then(msg => {
        this.dictfathers = msg
        this.loading = false
      }).catch(err => {
        this.$message.error(err)
        this.loading = false
      })
    },
    initdictsonlist () {
      this.$ajax.get('/base/dic/sonlist', { "selectFatherID": this.itemdetailInfo.dictFatherId }).then(msg => {
        this.sonlist = msg
      }).catch(err => {
        this.$message.error(err)
      })
    },
    //从后台查询指定字典子节点字段列表
    loaditemdetailList () {
      this.loadingItemdetail = true
      this.queryObj.orderBy = "type_id,instype_id,type_id,label+0"
      this.$ajax.get('/buss/item/detaillist', this.queryObj).then(msg => {
        this.itemdetailPageData = msg
        this.loadingItemdetail = false
      }).catch(err => {
        this.$message.error(err)
        this.loadingItemdetail = false
      })
    },


    //初始化添加父节点
    itemdetailAdd () {
      this.edititemdetailVisible = true
      this.itemdetailInfo = {}
      this.itemdetailInfo.type = 1
      this.doatypelist()
      this.detailtypeinit()

    },
    //初始化编辑父节点
    editItemdetailinit (row) {
      this.itemdetailInfo = JSON.parse(JSON.stringify(row))
      this.doatypelist()
      this.detailtypeinit()
      console.log(this.itemdetailInfo.dictFatherId)
      if (this.itemdetailInfo.dictFatherId != null && this.itemdetailInfo.dictFatherId != '') {
        this.initdictsonlist()
      }
      this.edititemdetailVisible = true

    },

    //保存父节点信息
    submititemdetail () {
      this.$refs["itemdetailForm"].validate(valid => {
        if (valid) {

          if (this.itemdetailInfo.instypeId == 1) {
            this.itemdetailInfo.instypeName = "设备巡检"
          }
          else {
            this.itemdetailInfo.instypeName = "区域巡检"
          }

          this.itemdetailInfo.isRequired = 1

          for (var s of this.doaType) {
            if (s.value == this.itemdetailInfo.typeId) {
              this.itemdetailInfo.typeIdName = s.label
              break
            }
          }

          if (this.itemdetailInfo.instypeId == 2) {
            for (var t of this.sysList) {
              if (t.id == this.itemdetailInfo.sysId) {
                this.itemdetailInfo.sysName = t.name
                break
              }
            }
          }
          else {
            this.itemdetailInfo.sysId = null;
            this.itemdetailInfo.sysName = null;
          }


          if (this.itemdetailInfo.type == 2 && this.dictfathers != null) {
            for (var item of this.dictfathers) {
              if (item.id === this.itemdetailInfo.dictFatherId) {
                this.itemdetailInfo.dictFatherName = item.name
                break
              }
            }
          }
          let dict = JSON.parse(JSON.stringify(this.itemdetailInfo))
          let url = "/buss/item/detailadd";
          if (dict.id != null) {
            url = "/buss/item/detailedit";
          }
          this.saving = true
          this.$ajax.post(url, dict).then(msg => {
            this.saving = false
            this.loaditemdetailList()
            this.edititemdetailVisible = false
            this.$message.success(msg)
          }).catch(err => {
            this.$message.error(err)
            this.saving = false
          })
        }
      })
    },
    //删除父节点信息
    itemdetailDel (delId) {
      let ids = []
      if (delId != null) {
        ids = [delId]
      }
      else {
        this.$refs["itemdetailTable"].selection.forEach((ele) => {
          ids.push(ele.id)
        })
      }
      if (ids.length > 0) {
        this.loading = true
        this.$ajax.post('/buss/item/detaildelete', { 'ids': ids }).then(msg => {
          this.loading = false
          this.$message.success(msg)
          this.queryObj.pageNum = 1//删除之后，回到第一页
          this.loaditemdetailList()
        }).catch(err => {
          this.$message.error(err)
          this.loading = false
        })
      }
    },

    detailtypeinit () {
      if (this.itemdetailInfo.type == 1 || this.itemdetailInfo.type == 3) {
        this.dictVisible = false
        this.maxVisible = true
      }
      if (this.itemdetailInfo.type == 2) {
        this.dictVisible = true
        this.maxVisible = false
      }
    },



  },
  mounted () {
    this.init()
  }
}
</script>
<style scoped></style>
